module.exports = __webpack_public_path__ + "img/Puffer.d7ff927c.jpg";